
export default {
  path: '/v2',
  component: r => require(['@/v2/views/components/BasePage'], r),
  children: [
    {
      path: '/v2/card/index',
      name: 'CardIndex',
      component: r => require(['@/v3/modules/card/views/index'], r),
      meta: {
        title: '答题卡制作',
        keepAlive: true
      }
    },
    {
      path: '/v2/card/third',
      name: 'ThirdPart',
      component: r => require(['@/v3/modules/card/views/third/index'], r),
      meta: {
        title: '第三方制卡',
        parentPath: '/v2/card/index'
      }
    },
    {
      path: '/v2/card/third/cut',
      name: 'CardCut',
      component: r => require(['@/v3/modules/card/views/third/cut'], r),
      meta: {
        title: '答题卡切题',
        parentPath: '/v2/card/index',
        hideHeader: 'hide-header',
        hideFooter: 'hide-footer'
      }
    },
    {
      path: '/v2/card/third/upload',
      name: 'CardUpload',
      component: r => require(['@/v3/modules/card/views/third/upload'], r),
      meta: {
        title: '上传答题卡',
        parentPath: '/v2/card/index'
      }
    },
    {
      path: '/v2/card/third-multiple',
      name: 'ThirdPartMutliple',
      component: r => require(['@/v3/modules/card/views/thirdmultiple/index'], r),
      meta: {
        title: '第三方制卡',
        parentPath: '/v2/card/index'
      }
    },
    {
      path: '/v2/card/third-multiple/upload',
      name: 'ThirdPartMutliple-CardUpload',
      component: r => require(['@/v3/modules/card/views/thirdmultiple/upload'], r),
      meta: {
        title: '上传答题卡',
        parentPath: '/v2/card/index'
      }
    },
    {
      path: '/v2/card/third-multiple/cut',
      name: 'ThirdPartMultiple-CardCut',
      component: r => require(['@/v3/modules/card/views/thirdmultiple/cut'], r),
      meta: {
        title: '答题卡切题',
        parentPath: '/v2/card/index',
        hideHeader: 'hide-header',
        hideFooter: 'hide-footer'
      }
    },
    {
      path: '/v2/card/third-multiple/preview',
      name: 'ThirdPartMultiple-Preview',
      component: r => require(['@/v3/modules/card/views/thirdmultiple/preview'], r),
      meta: {
        title: '预览答题卡模版',
        parentPath: '/v2/card/index',
        hideHeader: 'hide-header',
        hideFooter: 'hide-footer'
      }
    },
    {
      path: '/v2/card/cardeditor/card',
      name: 'CardPage',
      component: r => require(['@/v3/modules/card/views/cardeditor/card-page'], r),
      meta: {
        title: '答题卡制作',
        keepAlive: false,
        parentPath: '/v2/card/index',
        hideHeader: 'hide-header',
        hideFooter: 'hide-footer'
      }
    }
  ]
}
